import { getRoot } from 'mobx-state-tree';

import { PAGE_TYPES } from '../constants';

const Views = self => ({
  get isContact() {
    return self.type === PAGE_TYPES.PROFILE;
  },

  get isBulk() {
    return self.type === PAGE_TYPES.BULK;
  },

  get isLinkedinCompany() {
    // support in LinkedIn products (regular LinkedIn and Sales Navigator)
    return self.type === PAGE_TYPES.LINKEDIN_COMPANY;
  },

  get isCompanyPage() {
    return self.type === PAGE_TYPES.SALESFORCE_ACCOUNT || self.type === PAGE_TYPES.HUBSPOT_COMPANY || self.type === PAGE_TYPES.LINKEDIN_COMPANY;
  },

  get isSavedTab() {
    return self.pathName.includes('/saved');
  },

  get isScoutEmployeesTab() {
    return self.pathName === '/lusha-scout/employees' || self.pathName === '/lusha-scout/search/company/employees';
  },

  isNewProfileUrl(url) {
    return (self.isContact || self.isBulk) && url !== self.lastProfileUrl;
  },

  get contextTypeName() {
    switch (self.type) {
      case PAGE_TYPES.BULK:
        return 'bulk';
      case PAGE_TYPES.PROFILE:
        return 'profile';
      case PAGE_TYPES.LINKEDIN_COMPANY:
      case PAGE_TYPES.HUBSPOT_COMPANY:
      case PAGE_TYPES.SALESFORCE_ACCOUNT:
        return 'company';
      default:
        return 'unknown';
    }
  },

  get activeContacts() {
    const { app, savedTab, contact } = getRoot(self);

    if (self.isSavedTab) {
      return [savedTab.selectedContact];
    }

    if (self.isBulk) {
      return app.selectedContacts;
    }

    return [contact];
  },
});

export default Views;
